/**
 * Payment confirmation table
 * 
 */
import React, { Fragment } from 'react';
import moment from 'moment';
import './ConfirmationTable.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ConfirmationTable = props => {
  const {
    createdDateTime,
    id,
    paymentAmount,
    postageDescription
  } = props;
  const date = createdDateTime ? moment(createdDateTime) : moment(new Date());
  return /*#__PURE__*/_jsx(Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "ConfirmationTable",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "Text",
        children: [/*#__PURE__*/_jsx("div", {
          className: "label",
          children: "Successfully paid"
        }), /*#__PURE__*/_jsxs("div", {
          className: "value",
          children: ["$", paymentAmount]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "Text",
        children: [/*#__PURE__*/_jsx("div", {
          className: "label",
          children: "Date"
        }), /*#__PURE__*/_jsx("div", {
          className: "value",
          children: date.format('D MMMM YYYY')
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "Text",
        children: [/*#__PURE__*/_jsx("div", {
          className: "label",
          children: "Product"
        }), /*#__PURE__*/_jsx("div", {
          className: "value",
          children: "International Driving Permit"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "Text",
        children: [/*#__PURE__*/_jsx("div", {
          className: "label",
          children: "Order number"
        }), /*#__PURE__*/_jsx("div", {
          className: "value",
          children: id
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "Text",
        children: [/*#__PURE__*/_jsx("div", {
          className: "label",
          children: "Shipping method"
        }), /*#__PURE__*/_jsx("div", {
          className: "value",
          children: postageDescription
        })]
      })]
    })
  });
};
export default ConfirmationTable;